module.exports = __webpack_public_path__ + "static/5 - Raptor 2-957ed1452c7521360fc7ba576d950a8d.jpg";